import React, { useState } from "react";
import "./GameTabs.css";
import { FaClock } from "react-icons/fa";

function GameTabs({ activeTab, setActiveTab }) {


  const tabs = [
    { id: "30", label: "30 Sec", option_id: 1 },
    { id: "60", label: " 1 Min", option_id: 2 },
    { id: "120", label: " 2 Min", option_id: 3 },
    { id: "300", label: " 5 Min", option_id: 4 },
  ];

  return (
    <div className="game_tabs_parent">
      <div className="game_tabs">
        {tabs.map((tab) => (
          <div
            key={tab.id}
            className={`tab_item ${activeTab?.id === tab.id ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            <div className="tab_icon">
              <img
                src="/assets/images/icons/clock.png"
                className="clock_img"
                alt="clock"
              />
            </div>
            <p>{tab.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default GameTabs;
